/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DefaultPeriod
 */
export interface DefaultPeriod {
    /**
     * Number of days in past to backfill from. 0 is no backfill. e.g) if 10, then backfill last 10 days of data. Required if fullHistory is not set.
     * @type {number}
     * @memberof DefaultPeriod
     */
    days?: number;
    /**
     * If true, backfill all history. Required if days is not set.
     * @type {boolean}
     * @memberof DefaultPeriod
     */
    fullHistory?: boolean;
}

/**
 * Check if a given object implements the DefaultPeriod interface.
 */
export function instanceOfDefaultPeriod(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DefaultPeriodFromJSON(json: any): DefaultPeriod {
    return DefaultPeriodFromJSONTyped(json, false);
}

export function DefaultPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefaultPeriod {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'days': !exists(json, 'days') ? undefined : json['days'],
        'fullHistory': !exists(json, 'fullHistory') ? undefined : json['fullHistory'],
    };
}

export function DefaultPeriodToJSON(value?: DefaultPeriod | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'days': value.days,
        'fullHistory': value.fullHistory,
    };
}

